import { Tick, Warn } from "assets/icons"
import { useEffect, useMemo } from "react"
import "./index.css"

const Toast = ({
    message = "",
    type = "",
    onClose = () => { },
}) => {

    useEffect(() => {
        let timer
        if (type) {
            timer = setTimeout(() => {
                onClose()
            }, 30000)
        }
        return () => clearTimeout(timer)
    }, [type])

    const icons = useMemo(() => ({
        success: <Tick />,
        warning: <Warn />,
        error: <Warn />,
    }), [type])

    return (
        <div className="toast fixed top-5 right-5 flex items-center gap-3 bg-white shadow-lg p-4 rounded-lg border-l-4 transition-transform slide-in max-w-[80vw] sm:max-w-[40vw]">
            <span className={`rounded-full p-2 bg-${type}`}>
                {icons[type]}
            </span>
            <p className="text-[14px] text-black opacity-70">{message}</p>
        </div>
    )
}

export default Toast